import countAnimationGroup from './countAnimationGroup'
const scrollHorizontal = {}
scrollHorizontal.isReset = false
scrollHorizontal.scrollTimer = null
scrollHorizontal.scrollStopTimer = null
scrollHorizontal.isScroll = false
scrollHorizontal.icons = document.querySelectorAll('.icon')
scrollHorizontal.count = 0
scrollHorizontal.init = function(scrollWrap, moveWrap, scrollMode) {
  scrollHorizontal.scrollWrap = scrollWrap
  scrollHorizontal.moveWrap = moveWrap
  const posValue = 100
	scrollHorizontal.lastPos = 0;
  let ww = window.innerWidth

  /*
  if(scrollMode == 'native'){
    scrollWrap.setAttribute('style', 'overflow-x: auto; overflow-y: hidden; scroll-behavior: smooth;')
    // scrollWrap.setAttribute('style', 'overflow-x: auto; overflow-y: hidden;')
  }
  //*/

  scrollHorizontal.menu = document.querySelector('#menu')
  scrollHorizontal.menuItems = menu.querySelectorAll('.sc_item')
  scrollHorizontal.sections = scrollWrap.querySelectorAll('.section')
  
  scrollHorizontal.nextBtnWrap = document.querySelector(".next_btn_wrap")
  scrollHorizontal.nextBtns = scrollHorizontal.nextBtnWrap.querySelectorAll(".next_btn")

  scrollHorizontal.prevBtnWrap = document.querySelector(".prev_btn_wrap")
  scrollHorizontal.prevBtns = scrollHorizontal.prevBtnWrap.querySelectorAll(".prev_btn")
  /*
	scrollWrap.addEventListener('wheel', function(e) {
    e.preventDefault()
    if(scrollHorizontal.isReset || scrollHorizontal.isScroll || !!window.noScroll){
      return
    }
    scrollHorizontal.isScroll = true
    clearTimeout(scrollHorizontal.scrollTimer)
    // console.log(scrollHorizontal.scrollTimer)

    let y = e.deltaY
    let x = e.deltaX
    
    // let p = posValue
    // let isTouchpad = false

    // scrollHorizontal.count += 1
    // console.log(scrollHorizontal.count)

    /*
    if(Math.abs(x)>0){
      scrollHorizontal.scrollTimer = setTimeout(()=>{
        scrollHorizontal.isScroll = true
        setTimeout(()=>{
          scrollHorizontal.lastPos = scrollWrap.scrollLeft
          scrollHorizontal.isScroll = false
          scrollHorizontal.count = 0
        },100)
      },50)
      scrollHorizontal.scrollFinish()
      return
    }
    //*
    if(scrollHorizontal.count >=scrollHorizontal.sections.length){
      scrollHorizontal.isScroll = false
      scrollHorizontal.count = 0
      scrollHorizontal.scrollFinish()
      return
    }
    //*

    Array.prototype.forEach.call(scrollHorizontal.icons, icon => {
      if(icon.className.search('tree')==-1){
        const img = icon.querySelector('img')
        img.setAttribute('style', `transform: translateX(${y/5}px)`)
        setTimeout(()=>{
          img.setAttribute('style', `transform: translateX(0)`)
        },500)
      }
    })
    //*
    ww = window.innerWidth
    const moveWrap_w = moveWrap.clientWidth
    if(scrollMode == 'auto'){
      scrollHorizontal.isScroll = true
      scrollHorizontal.nextSection = null
      if(y > 0 || x > 0){
        Array.prototype.forEach.call(scrollHorizontal.sections, (section, index) => {
          const rect = section.getBoundingClientRect()
          if(!scrollHorizontal.nextSection && rect.x > 0){
            scrollHorizontal.nextSection = section
          }
        })
      }else if(y < 0 || x < 0){
        Array.prototype.forEach.call(scrollHorizontal.sections, section => {
          const rect = section.getBoundingClientRect()
          if(rect.x + rect.width < window.innerWidth){
            scrollHorizontal.nextSection = section
          }
        })
      }
      if(!!scrollHorizontal.nextSection){
        scrollHorizontal.nextSection.scrollIntoView({ behavior: "smooth", block: "start"})
        window.location.hash = scrollHorizontal.nextSection.id
      }
      scrollHorizontal.scrollTimer = setTimeout(()=>{
        setTimeout(()=>{
          scrollHorizontal.isScroll = false
          scrollHorizontal.nextSection = null
        },1000)
        scrollHorizontal.scrollFinish()
      },500)
    }else{
      if(y > 0 || x > 0){
        if(moveWrap_w - scrollWrap.scrollLeft > ww){ 
          scrollHorizontal.lastPos = parseInt(moveWrap_w - (scrollHorizontal.lastPos + posValue ) > ww ? scrollHorizontal.lastPos + posValue : moveWrap_w - ww)
        }
      }else if(y < 0 || x < 0){
        if(scrollHorizontal.lastPos > 0){ 
          scrollHorizontal.lastPos = parseInt(moveWrap_w + scrollHorizontal.lastPos > 0 ? scrollHorizontal.lastPos - posValue : 0)
        }else{
          scrollHorizontal.lastPos = 0
        }
      }
      if(y !== e.wheelDeltaY * -3){
        // console.log(y!== e.wheelDeltaY * -3)
        scrollHorizontal.scrollTimer = setTimeout(()=>{
          scrollHorizontal.isScroll = true
          scrollWrap.scrollLeft = scrollHorizontal.lastPos
          // console.log('timer')
          setTimeout(()=>{
            scrollHorizontal.isScroll = false
            scrollHorizontal.count = 0
          },100)
          scrollHorizontal.scrollFinish()
        },50)
      }
    }


    /*
    else {
      const rect = moveWrap.getBoundingClientRect()
      if(y > 0){
        if(moveWrap_w-lastPos>ww){
          lastPos = parseInt(moveWrap_w - (lastPos + posValue) > ww ? lastPos + posValue : moveWrap_w-ww)
        }
      }else{
        if(lastPos>0){
          lastPos = parseInt(moveWrap_w+lastPos>0?lastPos-posValue:0)
        }
      }
      moveWrap.setAttribute('style', `width: ${moveWrap_w}px; transform: translateX(-${lastPos}px)`)
    }
    //*/
    

    /*
    const qs = queryString.parse()
    if(!!qs.sec){
      document.querySelector(`#${qs.sec}`).scrollIntoView({ behavior: "smooth", block: "start" })
      const menu = document.querySelector('.menu')
      const menuItems = menu.querySelectorAll('.sc_item')
      const activeItem = document.querySelector(`.menu_${qa.sec}`)
      // Array.prototype.forEach.call(menuItems, item => {
      // })
    }
    //*
  });
  //*/

  /*
  scrollHorizontal.touch = false
  scrollHorizontal.startX = null
  scrollHorizontal.moveX = null
  scrollHorizontal.moveVal = 30
  scrollWrap.addEventListener('touchstart', function(e) {
    scrollHorizontal.touch = true
    scrollHorizontal.startX = e.touches[0].pageX
  })
  scrollWrap.addEventListener('touchmove', function(e) {
    scrollHorizontal.moveX = e.touches[0].pageX
  })
  scrollWrap.addEventListener('touchend', function(e) {
    ww = window.innerWidth
    scrollHorizontal.isScroll = true
    if(scrollHorizontal.touch && !!scrollHorizontal.moveX) {
      // console.log(scrollHorizontal.moveX , scrollHorizontal.startX )
      if(scrollHorizontal.moveX < scrollHorizontal.startX+scrollHorizontal.moveVal){
          Array.prototype.forEach.call(scrollHorizontal.sections, (section, index) => {
            const rect = section.getBoundingClientRect()
            if(!scrollHorizontal.nextSection && rect.x > 0){
              scrollHorizontal.nextSection = section
            }
          })
      }else if(scrollHorizontal.moveX > scrollHorizontal.startX+scrollHorizontal.moveVal){
        Array.prototype.forEach.call(scrollHorizontal.sections, section => {
          const rect = section.getBoundingClientRect()
          if(rect.x + rect.width < window.innerWidth){
            scrollHorizontal.nextSection = section
          }
        })
      }
      if(!!scrollHorizontal.nextSection){
        scrollHorizontal.nextSection.scrollIntoView({ behavior: "smooth", block: "start"})
        window.location.hash = scrollHorizontal.nextSection.id
      }
      scrollHorizontal.scrollTimer = setTimeout(()=>{
        setTimeout(()=>{
          scrollHorizontal.isScroll = false
          scrollHorizontal.nextSection = null
        },100)
        scrollHorizontal.scrollFinish()
      },500)
    }
    scrollHorizontal.touch = false
    scrollHorizontal.startX = null
    scrollHorizontal.moveX = null
  })
  //*/
}

scrollHorizontal.scrollFinish = function(){
  Array.prototype.forEach.call(scrollHorizontal.sections, (section, index) => {
    const ww = window.innerWidth
    const rect = section.getBoundingClientRect()
    const section_w = section.clientWidth
    if(rect.x<=ww*.5 && rect.x + section_w > ww*.5){
      section.classList.add('active')

      const activeItem = document.querySelector(`.menu_${section.id}`)
      activeItem.classList.add('active')
      // setPeopleBoxWidth.setWidth(index)

      /*
      const chronicleSliderWraps = section.querySelectorAll('.chronicle_slider_wrap')
      if(chronicleSliderWraps.length>0){
        Array.prototype.forEach.call(chronicleSliderWraps, t => {
          const id = parseInt(t.getAttribute('data-id'))
          window.chronicleSliderTns[id].play()
        })
      }
        //*/

      const countGroup = section.querySelectorAll('.count_group')
      if(!!countGroup){
        countAnimationGroup.count(countGroup)
      }

      Array.prototype.forEach.call(scrollHorizontal.menuItems, item => {
        if(item !== activeItem){
          item.classList.remove('active')

          /*
          const chronicleSliderWraps = item.querySelectorAll('.chronicle_slider_wrap')
          if(chronicleSliderWraps.length>0){
            Array.prototype.forEach.call(chronicleSliderWraps, t => {
              const id = parseInt(t.getAttribute('data-id'))
              window.chronicleSliderTns[id].pause()
            })
          }
          //*/
        }
      })
      Array.prototype.forEach.call(scrollHorizontal.prevBtns, btn => {
        const id = btn.getAttribute('data-show-id')
        if(id == section.id){
          btn.classList.add('active')
        }else{
          btn.classList.remove('active')
          btn.classList.remove('points_prev_hide')
        }
      })
      Array.prototype.forEach.call(scrollHorizontal.nextBtns, btn => {
        const id = btn.getAttribute('data-show-id')
        if(id == section.id){
          btn.classList.add('active')
        }else{
          btn.classList.remove('active')
          btn.classList.remove('points_next_hide')
        }
      })
    }else{
      section.classList.remove('active')
      const countGroup = section.querySelectorAll('.count_group')
      if(!!countGroup){
        countAnimationGroup.reset(countGroup)
      }
    }
  })
}
scrollHorizontal.resetPos = function(id){
  scrollHorizontal.lastPos = scrollHorizontal.scrollWrap.scrollLeft
  scrollHorizontal.isReset = false
  if(!!id){
    Array.prototype.forEach.call(scrollHorizontal.sections, section => {
      if(id == section.id){
        section.classList.add('active')
      }else{
        section.classList.remove('active')
      }
    })
    Array.prototype.forEach.call(scrollHorizontal.prevBtns, btn => {
      if(id == btn.getAttribute('data-show-id')){
        btn.classList.add('active')
      }else{
        btn.classList.remove('active')
      }
    })
    Array.prototype.forEach.call(scrollHorizontal.nextBtns, btn => {
      if(id == btn.getAttribute('data-show-id')){
        btn.classList.add('active')
      }else{
        btn.classList.remove('active')
      }
    })
  }
}

export default scrollHorizontal